import { cx } from '@/ui/cx';

const LEVELS = ['МЯГКО', 'ОСТРО', 'ЖЁСТКО'];

export interface IntensityPickerProps {
  value: number;
  onChange: (value: number) => void;
}

/**
 * Уровень заданий — три ячейки, выбранные залиты акцентом (design-spec.md,
 * 02 · Настройка партии). Заливка накопительная: выбор «ОСТРО» заливает и
 * «МЯГКО» — `maxIntensity` это потолок, а не точечная категория.
 *
 * Высота — `tap` (64px), а не буквальные 50px из макета: три однопальцевых
 * кнопки без соседних элементов внутри строки обязаны соответствовать
 * тап-зоне ≥64px, и здесь ничего не мешает выдержать её без компромиссов
 * (в отличие от строки игрока, где 58px — уже сознательный токен `row`).
 */
export function IntensityPicker({ value, onChange }: IntensityPickerProps) {
  return (
    <div className="mt-6">
      <p className="text-meta uppercase text-mute">Уровень заданий</p>
      <div className="mt-2 flex h-tap gap-1">
        {LEVELS.map((label, index) => {
          const level = index + 1;
          const active = level <= value;
          return (
            <button
              key={label}
              type="button"
              aria-pressed={active}
              onClick={() => onChange(level)}
              className={cx(
                'flex flex-1 appearance-none items-end rounded-none px-3 pb-3 text-left font-display text-meta',
                active ? 'bg-acc text-ground' : 'border-2 border-line bg-panel text-mute',
              )}
            >
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
